import "../../../bryntum-lib/editors/ResourceEditorV2/SwivuResourceEditorV2.jsx";
import SwivuModal from "./SwivuModal.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { useCallback } from "react";

const SwivuResourceEditorV2 = ({
  context,
  record,
  onClose,
  isShow,
  editorInstance
}) => {
  const { resource, selectTabByTypeOnOpen, selectTabByDeepLinkSlugOnOpen, note, checklist } = record || {};
  const onShowHandler = useCallback(
    (editor, otherParams = {}) => {
      /* Bug: Using Duplicate entity helper selecting an existing record and then opening a new editor causes previous editor to loose the selected record since react state is not updated with the widgets record.
      Fix: Assigning react state to bryntum's widget, lets us mutate react state from inside the widget instance.

      We are setting react state before invocation of editRecord because if a user opens a phantom record then through editRecord editor triggers a change event in all fields, if a field is using reactState property i.e, Duplicate Entity Helper then we might encounter errors. Therefore, setting reactState before editRecord trigger fixes these issues. */
      editorInstance.recordKey = "resource";
      editor.reactState = editorInstance;

      editor.project = context.project;
      editor.editRecord(
        resource,
        context,
        Object.assign(otherParams, { selectTabByTypeOnOpen, selectTabByDeepLinkSlugOnOpen, note, checklist })
      );
      editorInstance.editorRef = editor;
    },
    [context, editorInstance, resource]
  );
  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.resourceEditorV2Type}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  );
};

export default SwivuResourceEditorV2;
